import { Controller } from '@hotwired/stimulus'
import { csrfHeaders } from '@/utils/csrf'

export default class extends Controller {
  static values = { url: String, filter: { type: String, default: '' } }
  static targets = ['id']

  // SortableJS is imported on connect rather than at the top of the file: this controller is
  // registered on every page and a static import put the library into the bundle each of them
  // loads. The token makes a connect that Turbo disconnected mid-import bail out, so it never
  // leaves an instance that disconnect() has already missed.
  async connect() {
    const token = (this.connection = {})
    const { default: Sortable } = await import('sortablejs')
    if (this.connection !== token) return

    const options = {
      handle: ".drag-handle",
      animation: 150,
      onEnd: this.updatePositions.bind(this),
    }

    if (this.filterValue) {
      options.filter = this.filterValue
      options.preventOnFilter = false
    }

    this.sortable = Sortable.create(this.element, options);
  }

  // The curation screen replaces this element over Turbo on every pin and hide, so
  // connect() runs again each time. Without tearing the old instance down, every click
  // left a SortableJS instance behind holding a detached element and its listeners.
  disconnect() {
    this.connection = null
    this.sortable?.destroy()
    this.sortable = null
  }

  updatePositions(event) {
    const url = this.urlValue;

    fetch(url, {
      method: 'PATCH',
      headers: csrfHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ ids: this.orderedIds() }),
    });
  }

  orderedIds() {
    return this.idTargets.map(elem => elem.innerText)
  }
}
